import { set, when } from 'cerebral/operators'
import { state } from 'cerebral/tags'

export default [
  set(state`startPage.show`, false),
  when(state`app.currentView`, view => view === 'startpage'),
  {
    true: [
      set(state`node.tree.open`, true),
      set(state`app.currentView`, 'media'),
      set(state`node.showMenuToggle`, true)
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Startpage/chains/onHideStartPage.js